import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-sidebar-documentation',
  templateUrl: './sidebar-documentation.component.html',
  styleUrls: ['./sidebar-documentation.component.scss'],
})
export class SidebarDocumentationComponent implements OnInit {

  @Input() data: any;
  
  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    // console.log(this.menu);
  }

  irInicio() {
    this.router.navigateByUrl('/');
    // this.navController.navigateRoot('inicio');
  }

  viewTo(to, item?) {
    $('.btn_a-sidebar-doc').removeClass('active');
    $(`#${to}-tab`).addClass('active');
    $('.content-tab').hide();
    $(`#${to}`).show();
  }

}
